import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import { MailOutline as SubscriptionIcon } from '@magalu/stereo-ui-icons';
import HiddenLabel from '../HiddenLabel';
import { Form } from './subscription-form.styles';

const SubscriptionForm = ({
  title,
  policy,
  onSubmitForm
}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = (e, onSubmit) => {
    onSubmit(e, {
      name,
      email
    });
  };

  return /*#__PURE__*/React.createElement(Form, {
    "data-testid": "subscription-form-elem",
    onSubmit: e => handleSubmit(e, onSubmitForm)
  }, /*#__PURE__*/React.createElement(Form.Header, null, /*#__PURE__*/React.createElement(SubscriptionIcon, {
    "data-testid": "link-icon",
    color: "currentColor",
    width: 25
  }), /*#__PURE__*/React.createElement(Form.Title, null, title), /*#__PURE__*/React.createElement(Form.Link, {
    "data-testid": "link-policy",
    underline: true,
    href: policy == null ? void 0 : policy.url
  }, policy == null ? void 0 : policy.label)), /*#__PURE__*/React.createElement(Form.InputWrapper, null, /*#__PURE__*/React.createElement(HiddenLabel, {
    text: "digite o seu nome",
    htmlFor: "input-name"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    id: "input-name",
    "data-testid": "input-name",
    placeholder: "digite o seu nome",
    value: name,
    onChange: e => setName(e.target.value)
  }), /*#__PURE__*/React.createElement(HiddenLabel, {
    text: "digite o seu email",
    htmlFor: "input-email"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    id: "input-email",
    "data-testid": "input-email",
    placeholder: "digite o seu email",
    type: "email",
    value: email,
    onChange: e => setEmail(e.target.value)
  }), /*#__PURE__*/React.createElement(Form.SubmitBtn, {
    "data-testid": "submit-btn",
    disabled: !email || !name,
    type: "submit",
    onClick: e => handleSubmit(e, onSubmitForm)
  }, "Enviar")));
};

process.env.NODE_ENV !== "production" ? SubscriptionForm.propTypes = {
  title: string.isRequired,
  policy: shape({
    label: string.isRequired,
    url: string.isRequired
  }).isRequired,
  onSubmitForm: func.isRequired
} : void 0;
export default SubscriptionForm;